export default __webpack_public_path__ + "static/media/icon_smackthefly.86289b79.png";